import About from './components/About';
import Conact from './components/Conact';
import Expirience from './components/Expirience';
import Footer from './components/Footer';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Portfolio from './components/Portfolio';
import SocialLinks from './components/SocialLinks';

function App() {
	return (
		<>
			<Navbar />
			<Home />
			<About />
			<Portfolio />
			<Expirience />
			<Conact />
			<Footer />

			<SocialLinks />
		</>
	);
}

export default App;
